import React from "react";
import PageHero from "../components/layout/PageHero";
import Reveal from "../components/Reveal";
import Icon from "../components/Icon";
import { Process } from "../components/home/Process";
import { useContent } from "../context/ContentContext";
import { mediaUrl } from "../api";
import { ArrowUpRight } from "lucide-react";
import { useRFQ } from "../context/RFQContext";

export default function Services() {
  const { openRFQ } = useRFQ();
  const { content } = useContent();
  const services = content.services || [];
  const images = content.images || {};
  return (
    <>
      <PageHero
        eyebrow="What we do"
        title="Full Support, Start to Finish"
        subtitle="Support from product brief to delivery — sourcing, documentation and supply-chain coordination built into one service model."
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 80}>
              <div className="group h-full bg-card rounded-2xl border border-border p-8 hover:border-[#2ED9B8]/30 hover:shadow-[0_24px_50px_-30px_rgba(12,97,82,0.5)] transition-all duration-300">
                <div className="h-14 w-14 rounded-2xl brand-gradient flex items-center justify-center shadow-[0_12px_28px_-12px_rgba(12,97,82,0.7)]">
                  <Icon name={s.icon} className="h-7 w-7 text-white" strokeWidth={1.7} />
                </div>
                <h3 className="mt-6 font-display text-[22px] text-foreground">{s.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-muted-foreground">{s.desc}</p>
                <button onClick={openRFQ} className="tap-target mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#2ED9B8] hover:gap-2.5 transition-all">
                  Discuss this service <ArrowUpRight className="h-4 w-4" />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Image band */}
      <section className="pb-8">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal className="relative rounded-[28px] overflow-hidden">
            <img src={mediaUrl(images.portCrane)} alt="Global logistics" className="w-full h-[280px] lg:h-[360px] object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#06111d]/85 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="px-8 lg:px-14 max-w-lg">
                <h2 className="font-display text-[28px] lg:text-[38px] text-white leading-[1.1]">
                  One partner across the entire supply chain
                </h2>
                <p className="mt-3 text-white/75 text-[15px]">
                  From manufacturer matching to documentation and delivery, we coordinate every step.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <Process />
    </>
  );
}
